import { createSlice, type PayloadAction } from "@reduxjs/toolkit";
import type { RootState } from "store";
import type { LightingModeType } from "types";

type FridgeLightingSlice = {
	mode: LightingModeType | null;
};

const initialState: FridgeLightingSlice = {
	mode: null,
};

export const fridgeLightingSlice = createSlice({
	name: "lighting",
	initialState: initialState,
	reducers: {
		setLightingMode: (state, { payload }: PayloadAction<LightingModeType>) => {
			state.mode = payload;
		},
	},
});

export const { setLightingMode } = fridgeLightingSlice.actions;
export const selectFridgeLightingMode = (state: RootState): LightingModeType | null => state.lighting?.mode ?? null;

export default fridgeLightingSlice.reducer;
